import React, { Fragment } from "react";
import { FormGroup, Label, ListGroup, ListGroupItem, Row, Col } from "reactstrap";
import PropTypes from "prop-types";

import { CheckFormField, FormField, SelectFormField } from "../../../../../utils";
import { commissionForm } from ".";
import { OrderTable } from "./OrderTable/OrderTable";

function EventCommission({ events, event, eventErrors, handleChange, loading }) {
  return (
    <FormGroup>
      <Label>Event</Label>
      <ListGroup>
        {events.map((e, i) => (
          <ListGroupItem key={e.type}>
            <Row>
              <Col>{event[i].type}</Col>
              <Col>
                <FormField
                  disabled={loading}
                  label="Suggested"
                  value={event[i].volume}
                  name="volume"
                  type="number"
                  description={`Must be between ${parseFloat(e.min)}
                        ${e.minForm === commissionForm.Flat ? ` ${e.currencyISO}` : "%"} and ${parseFloat(
                    e.max
                  )}
                        ${e.maxForm === commissionForm.Flat ? ` ${e.currencyISO}` : "%"}.`}
                  error={eventErrors[i]}
                  onChange={(name, value) => handleChange(name, i, "event", value)}
                  dataTypeDecimalName="currency"
                />
              </Col>
              <Col>
                <SelectFormField
                  label="Form"
                  disabled={loading}
                  value={event[i].form.trim()}
                  name="form"
                  selectItems={Object.keys(commissionForm).filter(
                    (key) => e.maxForm.trim() === key || e.minForm.trim() === key
                  )}
                  getSelectItemId={(key) => key}
                  getSelectItemName={(key) =>
                    `${commissionForm[key]} (${key === commissionForm.Flat ? e.currencyISO.trim() : "%"})`
                  }
                  onChange={(name, value) => handleChange(name, i, "event", value)}
                />
              </Col>
            </Row>
            {event[i] === undefined ? null : Object.keys(events).length != 0 &&
              event[i].type === "Order" &&
              event[i].Group ? (
              <Fragment>
                <Row>
                  <Col xs="4" sm="4" md="4"></Col>
                  <Col xs="4" sm="4" md="4">
                    <FormField
                      label="Formula"
                      disabled={loading}
                      value={event[i].formula.trim() ? event[i].formula.trim() : "-"}
                    />
                  </Col>
                  <Col xs="4" sm="4" md="4"  style={{ alignItems: "end", display: "flex"}}>
                    <CheckFormField
                      label={"Adds to commission"}
                      initialValue={event[i].formulaadds}
                      disabled={true}
                      value={event[i].formulaadds}
                      name={"true"}
                    />
                  </Col>
                </Row>
              </Fragment>
            ) : null}
            {event[i] === undefined ? null : Object.keys(events).length != 0 &&
              event[i].type === "Order" &&
              event[i].Group ? (
              <OrderTable
                group={event[i].Group}
                loading={loading}
                handleChange={handleChange}
                i={i}
                eventErrors={eventErrors}
              />
            ) : null}
          </ListGroupItem>
        ))}
        {events.length === 0 && <ListGroupItem>No event Commissions</ListGroupItem>}
      </ListGroup>
    </FormGroup>
  );
}

EventCommission.propTypes = {
  events: PropTypes.array.isRequired,
  event: PropTypes.array.isRequired,
  eventErrors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default EventCommission;
